import {
  useCreateContext,
  useGetRecordRepresentation,
  useRecordContext,
  useResourceContext,
  useResourceDefinition,
} from "react-admin";
import { PageTitle } from "./PageTitle";
import { useAutovioContext } from "../hooks/useAutovioContext";
import { type ReactElement } from "react";
import { BackButton } from "../buttons/BackButton";

/**
 * If no `header` property is given, the record title is rendered inside an `<h2>` element.
 */
export function BackofficeRecordTitle({ header }: { header?: ReactElement }) {
  const resource = useResourceContext();
  const resourceDefinition = useResourceDefinition({ resource });
  const record = useRecordContext();
  const getRecordRepresentation = useGetRecordRepresentation(resource);
  const { defaultTitle: creatingRecord } = useCreateContext();
  const [{ drivingSchoolId }] = useAutovioContext();

  let title: any;

  if (creatingRecord) {
    title = resourceDefinition.options.createTitle;
  } else if (record) {
    title = getRecordRepresentation(record);
  }

  const pageTitle =
    title && typeof title === "string" ? (
      header ? (
        <PageTitle documentTitle={title}>{header}</PageTitle>
      ) : (
        <PageTitle>{title}</PageTitle>
      )
    ) : null;

  if (drivingSchoolId) {
    return pageTitle;
  }

  // If we are not on a driving school page (and therefore the sidebar is not visible) we show the BackButton ...
  return (
    <>
      <BackButton />
      {pageTitle}
    </>
  );
}
